
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.694 3.5h-.36a6.086 6.086 0 00-2.76.654 6.166 6.166 0 00-3.407 5.513l.007.318c.037.742.21 1.472.51 2.152l.045.094-1.203 3.61-.02.079a.5.5 0 00.652.554l3.61-1.204-.194-.09a6.087 6.087 0 002.76.653 6.166 6.166 0 005.513-3.41c.431-.853.655-1.799.653-2.758v-.332a6.159 6.159 0 00-5.806-5.832zm-.362 1h.307a5.153 5.153 0 014.862 4.86l-.001.307a5.088 5.088 0 01-.546 2.308 5.168 5.168 0 01-4.621 2.858 5.088 5.088 0 01-2.308-.546l-.092-.036a.5.5 0 00-.291.008l-2.851.949.95-2.85a.5.5 0 00-.028-.383 5.087 5.087 0 01-.546-2.307 5.167 5.167 0 012.856-4.62 5.09 5.09 0 012.309-.548z","fill":"#222"}})])
          )
        }
      }
    